module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-4-stg-003.0bef4674.json").toString();